import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[focus-trap]'
})
export class FocusTrapDirective {

  constructor(element: ElementRef) {
    this.element = element;
  }

  ngAfterViewInit() {
    this.focusNodes = Array.from(this.element.nativeElement.querySelectorAll(
      'div[tabindex="0"], ' +
      'a[href]:not([disabled]):not([tabindex="-1"]), ' +
      'button:not([disabled]):not([tabindex="-1"]), ' +
      'textarea:not([disabled]):not([tabindex="-1"]), ' +
      'input[type="text"]:not([disabled]):not([tabindex="-1"]), ' +
      'input[type="radio"]:not([disabled]):not([tabindex="-1"]), ' +
      'input[type="checkbox"]:not([disabled]):not([tabindex="-1"]), ' +
      'input[type="tel"]:not([disabled]):not([tabindex="-1"]), ' +
      'select:not([disabled]):not([tabindex="-1"])'));
  }

  tab() {
    if (this.curr) {
      const nextNodeIndex = Math.abs((this.focusNodes.indexOf(this.curr) + 1) % this.focusNodes.length);
      this.curr = this.focusNodes[nextNodeIndex];
      this.curr.focus();
    } else {
      this.curr = this.focusNodes[0];
      this.curr.focus();
    }
  }

  shiftTab() {
    if (this.curr) {
      const currentPosition = this.focusNodes.indexOf(this.curr);
      if (currentPosition === 0) {
        this.curr = this.focusNodes[this.focusNodes.length - 1];
        this.curr.focus();
        return;
      }
      const nextNodeIndex = Math.abs((this.focusNodes.indexOf(this.curr) - 1) % this.focusNodes.length);
      this.curr = this.focusNodes[nextNodeIndex];
      this.curr.focus();
    } else {
      this.curr = this.focusNodes[this.focusNodes.length - 1];
      this.curr.focus();
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      if (event.shiftKey) {
        this.shiftTab();
        return;
      }
      this.tab();
    }
  }
}
